'use client';
import './style.sass';

import React from 'react';
import {
    listPath,
    listTitle,
    targetList,
    listFrontend,
    listMatrixe,
    listBusiness,
    listResults,
} from './constans';
import TitleCase from '../../case-components/title-case';
import Target from '../reusable-components/target';
import Solution from '../reusable-components/layouts-component__skills-team/solution';
import Model from '../reusable-components/layouts-component__skills-team/model';
import Business from '../reusable-components/layouts-component__skills-team/business';
import Result from '../reusable-components/layouts-component__skills-team/results';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';

const SkillsTeam = () => {
    const casePathname = '/cases/development/skills-team';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section>
            <TitleCase
                img="/images/pic/skills-team/skillsteam.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="skills-team"
            />
            <Target title={targetList.title} description={targetList.description} />
            <Solution listFrontend={listFrontend} />
            <Model listMatrixe={listMatrixe} />
            <Business listFrontend={listBusiness} />
            <Result list={listResults} />
            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default SkillsTeam;
